if (!customElements.get('mobile-swatch-media-gallery')) {
    customElements.define('mobile-swatch-media-gallery', class MobileSwatchMediaGallery extends HTMLElement {
      constructor() {
        super();
        this.checkVisibility();
      }

      checkVisibility() {
        $(this).on('change', function(e) {
            $('[data-swatch]', this).hide();
            var $activeGallery = $('[data-swatch="'+e.detail.swatch.replace(' ', '_')+'"]', this)
            $activeGallery.show();
        })
        var currentSwatch = $(this).data('current-swatch');
        $('[data-swatch]', this).hide();
        $('[data-swatch="'+currentSwatch.replace(' ', '_')+'"]', this).show();
      }
    });
}